export const TIMEOUT_IN_MINUTES = 30;
export const FIVE_MINUTES = 5*60*1000